import React from "react";
import { Box, Grid, IconButton, Paper, Tooltip, Typography, useMediaQuery } from "@mui/material";
import { variants } from "../../../../variants/variants";
import { EmojiEventsOutlined } from "@mui/icons-material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "@emotion/react";
import BackButton from "../../../../common/BackButton";
import NavbarLayout from "../../../../common/NavbarLayout";
import { useDispatch } from "react-redux";
import { toggleOutlet } from "../../../Announcement/announcementSlice";

const WinnersNavbar = () => {
  const { pathname } = useLocation();
  const path = pathname.split("/")[3];
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("sm"));
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const handleClick = () => {
    if (path === "overview") {
      navigate("rnr/winners");
    } else {
      navigate("rnr/overview");
    }
  };

  const handleNavigateBack = () => {
    dispatch(toggleOutlet(false))
    navigate('/home/announcement/gatewaybox')
  }
  return (
    <NavbarLayout handleNavigate={handleNavigateBack}>
    <Grid container sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: 1 }}>
      <Grid item display={"flex"} justifyContent={"center"} alignItems={"center"}>
        <EmojiEventsOutlined
          sx={{ fontSize: isSm ? "2rem" : "2.75rem", background: "#0A4FAC", p: 1, color: "white", borderRadius: "8px" }}
        />
        <Typography component={"div"} ml={1}>
          RnR{" "}
          {!isSm ? (
            <Typography
              sx={{
                fontSize: variants.BODY,
                [theme.breakpoints.down("lg")]: {
                  fontSize: variants.TINY,
                },
              }}
            >
              Recognition is the greatest motivator
            </Typography>
          ) : (
            <Typography
              sx={{
                fontSize: variants.BODY,
                [theme.breakpoints.down("lg")]: {
                  fontSize: variants.TINY,
                },
              }}
            >
              Rewards and Recognition
            </Typography>
          )}
        </Typography>
      </Grid>

      <Box display={"flex"} alignItems={"center"} ml={"auto"}>
        {path === "overview" ? (
          <>
            <Typography
              fontSize={"12px"}
              sx={{
                [theme.breakpoints.down("lg")]: {
                  display: "none",
                },
              }}
            >
              Winners
            </Typography>
            <Tooltip title='Winners of RnR'>
              <IconButton className='backButton' onClick={handleClick} disableRipple>
                <EmojiEventsOutlined sx={{ color: "#000", mr: 0.5 }} />
              </IconButton>
            </Tooltip>
          </>
        ) : (
          <>
            <Typography
              fontSize={"12px"}
              sx={{
                [theme.breakpoints.down("lg")]: {
                  display: "none",
                },
              }}
            >
              What is RnR?{" "}
            </Typography>
            <Tooltip title='Overview of RnR'>
              <IconButton onClick={handleClick} disableRipple>
                <InfoOutlinedIcon sx={{ color: "#000", mr: 0.5 }} />
              </IconButton>
            </Tooltip>
          </>
        )}
      </Box>
    </Grid>
    </NavbarLayout>
  );
};

export default WinnersNavbar;
